import React, { useMemo, useContext } from 'react'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { take } from 'lib/arrayUtils'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { CruiseDurationOptions } from './CruiseWhenHowLong'
import CruiseWhenDesktopInput from './CruiseWhenDesktopInput'
import CruiseWhenMobileInput from './CruiseWhenMobileInput'

interface Props {
  onChange: (values: App.CruiseGlobalFilters) => void
  dropdownAnchorRef?: React.RefObject<HTMLElement>
}

function CruiseWhenInputFilter({ onChange, dropdownAnchorRef }: Props) {
  const { flexibleMonths, durationMax, durationMin } = useContext(GlobalSearchStateContext)

  const inputValue = useMemo(() => {
    const departureMonths = flexibleMonths?.split(',').filter(Boolean) ?? []

    const option = CruiseDurationOptions.find(opt => (opt.min ?? 0) >= durationMin && (opt.max ?? 0) <= durationMax)
    const limitVisible = option ? 1 : 3
    const more = departureMonths.length > limitVisible ? `+${departureMonths.length - limitVisible}` : ''
    const dates = take(departureMonths.map((d) => {
      const [year, month] = d.split('-')
      return `${month}/${year}`
    }), limitVisible)

    const dateValues = dates.length && `${dates.join(', ')} ${more}`
    return [dateValues, option?.name].filter(Boolean).join(' | ')
  }, [durationMax, durationMin, flexibleMonths])

  return <div>
    <CSSBreakpoint max="mobile">
      <CruiseWhenMobileInput onChange={onChange} inputValue={inputValue} />
    </CSSBreakpoint>

    <CSSBreakpoint min="tablet">
      <CruiseWhenDesktopInput
        onChange={onChange}
        inputValue={inputValue}
        dropdownAnchorRef={dropdownAnchorRef}
      />
    </CSSBreakpoint>
  </div>
}

export default CruiseWhenInputFilter
